import React, { useState, useRef } from 'react';
import { Button, Modal, Input, message, Spin, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import BackgroundIhealth from '../../../../static/img/icon-app-background-ihealth.png';
import IconIos from '../../../../static/img/icon-type-ios.png';
import IconAndroid from '../../../../static/img/icon-type-android.png';
import IconBack from '../../../../static/img/icon-back.png';
import IconIosEnTip from '../../../../static/img/icon-ios-en-tip.png';
import IconIosEnTip1 from '../../../../static/img/icon-ios-en-tip1.png';
import IconIosEnTip2 from '../../../../static/img/icon-ios-en-tip2.png';
import IconIosEnTip3 from '../../../../static/img/icon-ios-en-tip3.png';
import IconIosEnTip4 from '../../../../static/img/icon-ios-en-tip4.png';
import IconIosEnTip5 from '../../../../static/img/icon-ios-en-tip5.png';
import IconIosZhTip from '../../../../static/img/icon-ios-zh-tip.png';
import IconIosZhTip1 from '../../../../static/img/icon-ios-zh-tip1.png';
import IconIosZhTip2 from '../../../../static/img/icon-ios-zh-tip2.png';
import IconIosZhTip3 from '../../../../static/img/icon-ios-zh-tip3.png';
import IconIosZhTip4 from '../../../../static/img/icon-ios-zh-tip4.png';
import IconIosZhTip5 from '../../../../static/img/icon-ios-zh-tip5.png';
import axios from 'axios';
import PCPage from './pc'
import PhonePage from './phone';
import {APP_BASE_URL} from '../../../../static/constant/index'

const AppDetailsPage = (props) => {
    const navigate = useNavigate();
    const { TextArea } = Input;

    const [isGetData, setIsGetData] = useState(false)
    const [divWidth, setDivWidth] = useState(0);
    const [divHeight, setDivHeight] = useState(0);
    const [btColor, setBtColor] = useState('rgba(0, 0, 0, 0.1)');
    const ref = useRef(null);

    const [password, setPassword] = useState('')
    const [isPhone, setisPhone] = useState(false);
    const [isIPhone, setIsIPhone] = useState(false);
    const [isShowPassword, setIsShowPassword] = useState(false);

    const [appPlatform, setAppPlatform] = useState('');
    const [appIcon, setIcon] = useState(BackgroundIhealth);
    const [appName, setAppName] = useState('');
    const [appPlatformIcon, setPlatformIcon] = useState('');
    const [shortLinkTip, setShortLinkTip] = useState('');
    const [shortLink, setShortLink] = useState('');
    const [appVersion, setAppVersion] = useState('');
    const [appUpTime, setAppUpTime] = useState('');
    const [description, setDescription] = useState('');
    const [dlUrl, setDlUrl] = useState('');
    const [isShow, setIsShow] = useState(false);

    const [modalTitle, setModalTitle] = useState('');
    const [modalData1, setModalData1] = useState('');
    const [modalData2, setModalData2] = useState('');
    const [modalData3, setModalData3] = useState('');
    const [modalData4, setModalData4] = useState('');
    const [modalData5, setModalData5] = useState('');
    const [modalData6, setModalData6] = useState('');
    const [modalData7, setModalData7] = useState('');
    const [modalData8, setModalData8] = useState('');
    const [modalImg1, setModalImg1] = useState('');
    const [modalImg2, setModalImg2] = useState('');
    const [modalImg3, setModalImg3] = useState('');
    const [modalImg4, setModalImg4] = useState('');
    const [modalImg5, setModalImg5] = useState('');
    const [modalImg6, setModalImg6] = useState('');

    const [modalTitle2, setModalTitle2] = useState('');
    const [modalbt, setModalbt] = useState('');
    const [onlyDevice, setOnlyDevice] = useState('');

    React.useEffect(() => {
        setShortLink(window.location.href);
        isShowDL()
        getAppInfo(getQueryString("id"))
    

        // if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ||
        //     typeof navigator.wxuserAgent !== 'undefined') {
        //     message.success('点击右上角，选择浏览器打开', 5)
        // }
    }, [])


    function getAppInfo(id) {
        setIsGetData(true)
        var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        var region='CN';
        if (lang.substring(0, 2) !== 'zh') {
            region='US';
        }
        axios.get(APP_BASE_URL+'distribution/getAppInfo'
            , {
                params: {
                    id: id,
                    region: region,
                }

            }).then((res) => {
                setIsGetData(false)
                console.log('getAppInfo.', res)
                const data = res.data
                var size;
                if (data.size <= 1024) {
                    size = data.size + 'B'
                } else if (data.size <= 1024 * 1024) {
                    size = Math.round(data.size / 1024) + 'KB'
                } else if (data.size <= 1024 * 1024 * 1024) {
                    size = Math.round(data.size / 1024 / 1024) + 'MB'
                } else if (data.size <= 1024 * 1024 * 1024 * 1024) {
                    size = Math.round(data.size / 1024 / 1024 / 1024) + 'GB'
                }
                setIcon(data.icon)
                setAppName(data.projectName)
                setAppPlatform(data.platform);
                setDescription(data.description)
                if (data.platform === 'IOS') {
                    setPlatformIcon(IconIos)
                    setAppVersion(data.version + '(Build ' + data.bundleVersion + ") - " + size)
                } else {
                    setPlatformIcon(IconAndroid)
                    setAppVersion(data.versionName + '(Build ' + data.versionCode + ") - " + size)
                }

                const uagent = window.navigator.userAgent
                const isIOS = !!uagent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                const isAndroid = uagent.indexOf('Android') > -1 || uagent.indexOf('Adr') > -1
                if (data.hasPassword) {
                    setIsShowPassword(true);
                } else if ((isIOS && data.platform === 'IOS') || (isAndroid && data.platform === 'ANDROID')) {
                    getAppDownloadUrl(id, data.platform)
                }
                setModalData(data.platform, data.createdAt)

            }).catch((error) => {
                console.log('upload failed.', error)
            });
    }

    function getAppDownloadUrl(id, appPlatform, password) {
        setIsGetData(true)
        var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        var region='CN';
        if (lang.substring(0, 2) !== 'zh') {
            region='US';
        }
        axios.get(APP_BASE_URL+'distribution/getAppDownLoadUrl'
            , {
                params: {
                    id: id,
                    password: password,
                    region:region,
                }

            }).then((res) => {
                setIsGetData(false)
                console.log('getAppDownLoadUrl.', res)
                var url = ''
                if (res.data.message != null) {
                    message.error(res.data.message)
                }else if (res.data != null) {
                    setIsShowPassword(false)
                    if (appPlatform === 'IOS') {
                        url = 'itms-services://?action=download-manifest&url=' + res.data
                    } else {
                        url = res.data
                    }
                    console.log(url)
                    const uagent = window.navigator.userAgent
                    const isIOS = !!uagent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    const isAndroid = uagent.indexOf('Android') > -1 || uagent.indexOf('Adr') > -1

                    if ((isIOS && appPlatform === 'IOS') || (isAndroid && appPlatform === 'ANDROID')) {
                        setDlUrl(url)
                        setIsShow(true)
                    }
                } else {
                    message.error('password error')
                }
            }).catch((error) => {
                console.log('upload failed.', error)

            });

    }

    function isShowDL() {
        const uagent = window.navigator.userAgent
        const isIOS = !!uagent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        const isAndroid = uagent.indexOf('Android') > -1 || uagent.indexOf('Adr') > -1
        if (isAndroid) {
            setIsIPhone(false)
            setisPhone(true)
        } else if (isIOS) {
            setIsIPhone(true)
            setisPhone(true)
        } else {
            setIsIPhone(false)
            setisPhone(false)
        }

    }
    const showInpPassword = e => {
        if (e.target.value !== '') {
            setBtColor('#FF5300')
        } else {
            setBtColor('rgba(0, 0, 0, 0.1)')
        }
        setPassword(e.target.value);
    }
    const onCheckPassword = (appPlatform) => {
        getAppDownloadUrl(getQueryString("id"), appPlatform, password)
    }

    function setModalData(platform, createdAt) {
        setDivWidth(ref.current.clientWidth - 24);
        setDivHeight(document.body.offsetHeight - 24);
        var lang = (navigator.systemLanguage ? navigator.systemLanguage : navigator.language);
        if (lang.substring(0, 2) === 'zh') {
            setAppUpTime('更新于: ' + createdAt.substring(0, 10) + " " + createdAt.substring(11, 19))
            setOnlyDevice(platform === 'IOS' ? '只支持 iOS 设备' : '只支持 Android 设备')

            setModalTitle('“未受信任的企业级开发者”解决办法')
            setModalData1('因苹果公司的政策原因，在 iOS 系统中首次安装企业版应用时会出现“未受信任的企业级开发者”提示，如下图所示:')
            setModalData2('解决方法如下 (以 iOS 15系统为例)')
            setModalData3('1. 在手机中打开设置功能，选择“通用”；')
            setModalData4('2. 在通用中，选择"VPN与设备管理"功能；')
            setModalData5('3. 在VPN与设备管理中的企业级应用分类中，选择要安装的企业应用的文件名称 (与打开时的提示一致)，点击进入;')
            setModalData6('4. 进入企业签名页面后，确认企业签名中的公司名称与应用名称后，点击信任"企业签名公司名称"；')
            setModalData7('5. 点击弹框中的信任按钮；')
            setModalData8('6. 回到桌面，重新打开应用即可使用')
            setModalImg1(IconIosZhTip)
            setModalImg2(IconIosZhTip1)
            setModalImg3(IconIosZhTip2)
            setModalImg4(IconIosZhTip3)
            setModalImg5(IconIosZhTip4)
            setModalImg6(IconIosZhTip5)
            setShortLinkTip('或用手机浏览器输入这个网址：' + window.location.href)
            setModalTitle2('请输入访问密码')
            setModalbt('确认')


        } else {
            setAppUpTime('Updated at: ' + createdAt.substring(0, 10) + " " + createdAt.substring(11, 19))
            setOnlyDevice(platform === 'IOS' ? 'Only support iOS device' : 'Only support Android device')

            setModalTitle('The solution to Untrusted Enterprise Developer')
            setModalData1('Due to the policy of Apple Inc., when installing enterprise applications for the first time in the iOS system, a prompt "Untrusted Enterprise Developer" will appear. ')
            setModalData2('The solution is as follows (taking the iOS 15 system as an example):')
            setModalData3('1. Open the settings function on your phone and select "General"')
            setModalData4('2. In General, select "VPN & Device Management".')
            setModalData5('3. In the enterprise application category of profiles and device management, select the file name of the enterprise application you want to install (consistent with the prompt when opening) and click to enter.')
            setModalData6('4. After entering the enterprise signature page, confirm the company name and application name in the enterprise signature, and click "Trust".')
            setModalData7('5.Click the Trust button in the pop-up box.')
            setModalData8('6. Return to the desktop and reopen the application to use it.')
            setModalImg1(IconIosEnTip)
            setModalImg2(IconIosEnTip1)
            setModalImg3(IconIosEnTip2)
            setModalImg4(IconIosEnTip3)
            setModalImg5(IconIosEnTip4)
            setModalImg6(IconIosEnTip5)

            setShortLinkTip('or enter this website on your mobile browser: ' + window.location.href)

            setModalTitle2('Please enter the access password')
            setModalbt('Ok')
        }
    }

    return (
        <div ref={ref} style={{ height: '100%', width: '100%', }}>
            <Spin size="large" tip="Loading..." spinning={isGetData} >
                <PCPage
                    isPhone={isPhone}
                    appPlatform={appPlatform}
                    appIcon={appIcon}
                    appName={appName}
                    appPlatformIcon={appPlatformIcon}
                    shortLinkTip={shortLinkTip}
                    shortLink={shortLink}
                    appVersion={appVersion}
                    appUpTime={appUpTime}
                    description={description} />
                <PhonePage
                    isPhone={isPhone}
                    isIPhone={isIPhone}
                    appPlatform={appPlatform}
                    appIcon={appIcon}
                    appName={appName}
                    appPlatformIcon={appPlatformIcon}
                    shortLinkTip={shortLinkTip}
                    shortLink={shortLink}
                    appVersion={appVersion}
                    appUpTime={appUpTime}
                    description={description}
                    dlUrl={dlUrl}
                    isShow={isShow}
                    onlyDevice={onlyDevice}/>
            </Spin >
            <Modal
                closable={false}
                centered
                open={isShowPassword}
                footer={null}
                width={300}
                destroyOnClose={true}
                maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                bodyStyle={{ padding: '0px', width: '300px', background: 'ffffff', borderRadius: '10px' }}
                style={{ borderRadius: "10px", overflow: "auto" }}
            >
                <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100px' }}>
                    <div>
                        <div style={{ textAlign: 'center', marginTop: '10px' }}>{modalTitle2}</div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <TextArea
                                value={password}
                                onChange={showInpPassword}
                                style={{ width: '200px', height: '30px', resize: 'none', marginTop: '15px' }} />


                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="text" onClick={() => onCheckPassword(appPlatform)} style={{
                        width: '159px',
                        color: btColor, fontSize: '16px', width: '159.5px', height: '56px',border: 'none' 
                    }}>{modalbt}</Button>

                </div>


            </Modal>
            
        </div>
    );

    function getQueryString(name) {
        // 未传参，返回空
        if (!name) return null;
        // 查询参数：先通过search取值，如果取不到就通过hash来取
        var after = window.location.search;
        after = after.substr(1) || window.location.hash.split("?")[1];
        // 地址栏URL没有查询参数，返回空
        if (!after) return null;
        // 如果查询参数中没有"name"，返回空
        if (after.indexOf(name) === -1) return null;
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        // 当地址栏参数存在中文时，需要解码，不然会乱码
        var r = decodeURI(after).match(reg);
        // 如果url中"name"没有值，返回空
        if (!r) return null;
        return r[2];
    }
}

export default AppDetailsPage